export default __webpack_public_path__ + "static/media/pq_2.b2f88484.jpg";